import { Component, Host, Prop, h } from '@stencil/core'
import { type CoreIcon } from '@pollux-docaposte/core-design-system'

@Component({
  tag: 'cobalt-tag',
  styleUrl: 'cobalt-tag.css'
})
export class CobaltTag {
  /**
   * This is the text which will appear inside the tag.
   */
  @Prop() label!: string
  /**
   * Allows to change the size of the tag.
   */
  @Prop() size?: 'small' | 'medium' = 'medium'
  /**
   * Allows to change the color of the tag.
   */
  @Prop() color?:
    | 'brand'
    | 'status success'
    | 'status warning'
    | 'status error'
    | 'status information'
    | 'neutral'
    | 'additional color 1'
    | 'additional color 2'
    | 'additional color 3'
    | 'additional color 4' = 'brand'

  /**
   * Accept all icon names from @pollux-docaposte/icon-library. By using the core-toggle component you don't have to install it as dependency.
   *
   * The icon render only if `iconName` is defined.
   */
  @Prop() iconName?: CoreIcon['name'] = undefined
  render(): any {
    return (
      <Host>
        <core-tag label={this.label} size={this.size} color={this.color} iconName={this.iconName}></core-tag>
      </Host>
    )
  }
}
